import { useBreadcrumb } from "core/features/breadcrumbs";
import ContentPrevisaoOrcamentaria from "./components/ContentPrevisaoOrcamentaria";

function PrevisaoOrcamentariaListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      url: "/financeiro/previsao-orcamentaria",
      name: "Previsão Orçamentária",
    },
  ]);

  return (
    <>
      <ContentPrevisaoOrcamentaria />
    </>
  );
}

export default PrevisaoOrcamentariaListagemPage;
